import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("Veuillez renseigner un email valide")
    .required("Ce champs est requis"),
  password: yup.string().min(8).required("Ce champs est requis"),
});
